import React from 'react'
import "./Footer.scss";

type Props = {
    type?: string
}
const Footer = ({ type }: Props) => {
    return (
        <footer className={`${type ?? ""}`}>
            <div className="container">

                <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" target="_blank" rel="noopener noreferrer">
                    תנאי שימוש
                </a>
                &nbsp;
                <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" target="_blank" rel="noopener noreferrer">
                    ומדיניות פרטיות
                </a>
            </div>
            |
            <div className="container">
                <a href="https://yit.co.il/" target="_blank" rel="noopener noreferrer">
                    עיצוב, אפיון ופיתוח
                <div className="yit"></div>
                </a>
            </div>
        </footer>
    )
}

export default Footer
